// Contact Info section, including address ...
import React from 'react';

import TextField from '../lib/mdb/text-field';
import Selectize from '../lib/mdb/selectize';
import _get from 'lodash/get';
import {isDirectDebitCat} from '../lib/payment-utils';
import {StandardValidators} from '../lib/form-validator';

const ContactInfoName = ({config}) => {
    const {paymentConfig, messages} = config;

    let elements = [];
    elements.push(
        <div key="firstName" className="col-4">
            <TextField
                name="customer.firstName"
                description={messages["payment.contact.firstName.label"]}
                placeholder={messages["firstName.tip"]}
                className="md-form form-group"
                labelClass="bootstrap-label"
                validations={{
                    required: "First name is required",
                    name: messages["opp.validation.firstName.invalid"] || "First name is invalid"
                }}
                maxLength="32"
                autoComplete="off"
            />
        </div>
    );
    elements.push(
        <div key="lastName" className="col-4">
            <TextField
                name="customer.lastName"
                description={messages["payment.contact.lastName.label"]}
                placeholder={messages["lastName.tip"]}
                className="md-form form-group"
                labelClass="bootstrap-label"
                validations={{
                    required: "Last name is required",
                    name: messages["opp.validation.lastName.invalid"] || "Last name is invalid"
                }}
                maxLength="32"
                autoComplete="off"
            />
        </div>
    );
    if (paymentConfig.showMiddleName && !paymentConfig.promptBusinessName) {
    elements.push(
        <div key="middleName" className="col-4">
            <TextField
                name="customer.middleName"
                description={messages["payment.contact.middleName.label"]}
                placeholder={messages["middleName.tip"]}
                className="md-form form-group"
                labelClass="bootstrap-label"
                validations={{
                    //required: "Last name is required"
                    name: (value) => StandardValidators.name(value, false) ? '' : messages["opp.validation.middleName.invalid"] || "Middle name is invalid"
                }}
                maxLength="60"
                autoComplete="off"
            />
        </div>
    );
    }
    return (
        <div className="row mt-2">{elements}</div>
    );
};


const ContactInfoAddress = ({config}) => {
    const {paymentConfig, messages} = config,
        country = paymentConfig.country || 'US',
        emptyValue = messages["state.tip." + country],
        stateList = paymentConfig.states.map(item =>
            ({
                code: item.name, description: item.description
            }));

    return (
        <React.Fragment>
            <div key="AddressLines" className="row">
                <div className="col-12">
                    <TextField
                        name="customer.address.line1"
                        description={messages["opp.line1.label"]}
                        placeholder={messages["line1.tip"]}
                        className="md-form form-group"
                        labelClass="bootstrap-label"
                        validations={{
                            required: "Address line required",
                            noInvalidCharacters: 'No invalid characters'
                        }}
                        maxLength="60"
                        autoComplete="off"
                    />
                </div>
                <div className="col-12">
                    <TextField
                        name="customer.address.line2"
                        description={messages["opp.line2.label"]}
                        placeholder={messages["line2.tip"]}
                        className="md-form form-group"
                        labelClass="bootstrap-label"
                        validations={{
                            noInvalidCharacters: 'No invalid characters'
                        }}
                        maxLength="60"
                        autoComplete="off"
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-4 col-xs-12 customer-city-col">
                    <TextField
                        name="customer.address.city"
                        description={messages["city.label"]}
                        placeholder={messages["city.tip"]}
                        className="md-form form-group"
                        labelClass="bootstrap-label"
                        validations={{
                            required: 'City is required',
                            noInvalidCharacters: 'No invalid characters'
                        }}
                        maxLength="25"
                        autoComplete="off"
                    />
                </div>
                <div className=" col-4 col-xs-12 customer-state-col">
                    <Selectize
                        name="customer.address.state"
                        description={messages["state.label." + country]}
                        selectizeOptions={{
                            dropdownParent: "body",
                            highlight: false
                        }}
                        selectList={stateList}
                        autoComplete="off">
                        <option value="">{emptyValue}</option>
                    </Selectize>
                </div>
                <div className=" col-4 col-xs-12 customer-zipcode-col">
                    <TextField
                        name="customer.address.zipCode"
                        description={messages["zipCode.label." + country]}
                        placeholder="Customer ZIP code"
                        className="md-form form-group"
                        labelClass="bootstrap-label"
                        validations={{
                            required: 'Zip code is required',
                            zipCode: 'Not a valid zipCode'
                        }}
                        maxLength="9"
                        autoComplete="off"
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

const ContactInfoPhoneAndZip = ({config, state}) => {
    const {paymentConfig, messages} = config,
        country = paymentConfig.country || 'US',
        phoneRequired = paymentConfig.adPhoneCaptureRequired;

    let phoneDescription = messages["payment.contact.dayPhone.label"];
    if (!phoneRequired) {
        phoneDescription = `${phoneDescription} ${messages["optional.label"]}`;
    }

    let elements = [];

    if (paymentConfig.captureZipCode) {
        elements.push(
            <div key="customerZipCode" className="col-4 col-xs-12">
                <TextField
                    name="customer.address.zipCode"
                    description={messages["zipCode.label." + country]}
                    placeholder="Customer ZIP code"
                    className="md-form form-group"
                    labelClass="bootstrap-label"
                    validations={{
                        required: 'Zip code is required',
                        zipCode: 'Not a valid zipCode'
                    }}
                    maxLength="9"
                    autoComplete="off"
                />
            </div>
        );
    }

    if (paymentConfig.capturePhone) {
        elements.push(
            <div key="customerDaytimePhoneNumber" className=" col-4 col-xs-12">
                <TextField
                    name="customer.dayPhoneNr"
                    description={phoneDescription}
                    className="md-form form-group"
                    placeholder={messages["dayPhone.tip"]}
                    onBlur={(e) => {
                        state.setValue("customer.dayPhoneNr", e.target.rawValue);
                    }}
                    validations={{
                        required: (value) => (phoneRequired && !value) ? messages["opp.validation.phone.required"] 
                                                                       || 'Daytime phone number is required'  : '',
                        regexp: {regexps: /^[0-9]{3}[ ]*[0-9]{3}[ ]*[0-9]{4}$/, msg: 'Not a valid phone number'}
                    }}
                    cleaveOptions={{phone: true, phoneRegionCode: 'US'}}
                />
            </div>
        );
        elements.push(
            <div key="customerDaytimePhoneExt" className=" col-2 col-xs-6">
                <TextField
                    name="customer.dayPhoneExt"
                    className="md-form form-group"
                    placeholder="Ext. (optional)"
                    validations={{regexp: {regexps: /^\d{0,10}$/, msg: 'Extension is not valid'}}}
                />
            </div>
        );
    }

    return (
        <div className="row">{elements}</div>
    );
};


const ContactInfoEmail = ({config, data}) => {
    const
        {paymentConfig, messages} = config,
        {emailConfirmationOptOutEnabled} = paymentConfig,
        emailRequired = paymentConfig.emailRequired;

    let emailDescription = messages["email.label"];
    if (!emailRequired) {
        emailDescription += ` ${messages["optional.label"]}`;
    }
    return (
        <React.Fragment>
            <div className="email-rows">
                <div className="row">
                    <div className="col-12">
                        <p className="font-small">{messages["contactInfo.emailUsageLabel"]}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-12">
                        <TextField
                            name="customer.email"
                            description={emailDescription}
                            placeholder={messages["email.tip"]}
                            className="md-form form-group"
                            labelClass="bootstrap-label"
                            validations={{
                                email: messages["email.invalid"],
                                notContainsCreditCardNumber: messages["input.invalidCC"],
                                required: (value, state) => (emailRequired && !value) ? messages["email.empty"] : ''
                            }}
                            maxLength="60"
                            autoComplete="off"
                        />
                    </div>
                    <div className="col-md-6 col-12">
                        <TextField
                            name="customer.email2"
                            description={messages["retypeEmail.label"]}
                            placeholder={messages["email.tip"]}
                            className="md-form form-group"
                            labelClass="bootstrap-label"
                            validations={{
                                email: messages["email.invalid"],
                                emailTheSame: function (value, state) {
                                    const email1 = _get(state, 'customer.email') || "";
                                    value = value || "";
                                    if (email1.toLowerCase() !== value.toLowerCase()) {
                                        return messages["email2.notMatch"];
                                    }
                                    return '';
                                }
                            }}
                            maxLength="60"
                            autoComplete="off"
                        />
                    </div>
                </div>
            </div>
            {emailConfirmationOptOutEnabled && (
                <div className="form-group form-group mb-0">
                    <input name="customer.emailConfirmationOptOut"
                           type="checkbox"
                           id="emailConfirmationOptOut-true"
                           value="true"
                           onChange={this.onChange}
                    />
                    <label htmlFor="emailConfirmationOptOut-true">
                        {messages["preferences.email.optout"]}</label>
                </div>
            )}
        </React.Fragment>
    );
};


class ContactInfoSection extends React.Component {
    constructor(props) {
        super(props);
        this.addContactInfoSections = this.addContactInfoSections.bind(this);
    }

    addContactInfoSections() {
        const {config, data, appComponents, state} = this.props,
            {paymentConfig} = config,
            {ContactInfoEmail, ContactInfoName, ContactInfoPhoneAndZip} = appComponents;

        let contactInfoSections = [];

        if (paymentConfig.captureCustomerInfo) {
            if (paymentConfig.captureNames) {
                contactInfoSections.push(
                    <ContactInfoName
                        key="ContactInfoName"
                        config={config}
                        state={state}/>
                );
            }

            if (paymentConfig.captureAddress) {
                contactInfoSections.push(
                    <ContactInfoAddress
                        key="ContactInfoAddress"
                        config={config}/>
                );
            }
            if (paymentConfig.capturePhone || paymentConfig.captureZipCode) {
                contactInfoSections.push(
                    <ContactInfoPhoneAndZip
                        key="ContactInfoPhoneAndZip"
                        config={config}
                        state={state}
                    />
                );
            }
        }

        if (paymentConfig.captureEmail) {
            contactInfoSections.push(
                <ContactInfoEmail
                    key="ContactInfoEmail"
                    config={config}
                    data={data}/>
            );
        }

        return contactInfoSections;
    }

    render() {
        const {config, active, showIcon} = this.props,
            {messages} = config;

        let contactInfoSections = this.addContactInfoSections();

        return (
            <div className={"opp-section" + (!active ? " disable-section" : "")} id="ContactInfo">
                <h3 className="section-title">
                    {showIcon && (
                        <span className="section-icon">
                        <img src={messages["opp.icon-contact-info"] || "images/icon-contact-information.png"}
                             alt="Contact Information"/>
                    </span>)
                    }
                    <span className="section-text">{messages["otp.personalInfo.title"]}</span>
                </h3>
                <div className="row">
                    <div className="col-12">
                        <div className="card card-v2">
                            <div className="card-body">{contactInfoSections}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};


export {ContactInfoSection,
        ContactInfoEmail,
        ContactInfoName,
        ContactInfoPhoneAndZip
};
